<template>
  <tr class="ce-productDetails-formulationsList-row">
    <td>
      <ColorSpaceBadge
        v-if="color"
        :color="color" />
      {{ row.shade.title }}
    </td>
    <td>
      <a
        :href="row.link">
        {{ row.title }}
      </a>
    </td>
  </tr>
</template>

<script>
import { mapState } from 'vuex';
import ColorSpaceBadge from 'components/ColorSpaceBadge.vue';

export default {
  components: { ColorSpaceBadge },
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['fieldManifest']),
    color() {
      if (this.row.shade.color) {
        return this.fieldManifest.color_space.optionsConfig.find((c) => c.code === this.row.shade.color);
      }

      return null;
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base.less';

.ce-productDetails-formulationsList-row {
  a {
    color: @color-text-base;
    text-decoration: underline;

    &:hover {
      color: @color-light;
    }
  }

  td:first-child {
    display: flex;
    align-items: center;

    .ce-colorBadge-holder {
      margin-right: @space-2;

      .ce-colorBadge {
        width: 20px;
        height: 20px;
        margin: 0;
      }
    }
  }
}
</style>
